import React from 'react';
import get from 'lodash/get';

import SystemMessageWrapperContext from '../../wrapper/context/SystemMessageWrapperContext';
import ContactUs from '../../contact-us/ContactUs';

import { __t, applyTranslations } from 'utils/language';
import { FUNC_RETURN_NULL } from 'modules/messenger/components/system/v2/utils/system-message';

import './payout-rescheduled-other.scss';

applyTranslations(require('./payout-rescheduled-other.i18n.json'));

interface Props {
  isBrand: boolean
}

const MSG_KEY = 'payout_rescheduled_other';

const PayoutRescheduledOther = ({ isBrand }: Props) => {
  const {
    message,
    renderAvatar = FUNC_RETURN_NULL
  } = React.useContext(SystemMessageWrapperContext);

  const ticket = get(message, 'metadata.ticket', null);
  const campaignName = get(message, 'metadata.campaign.name', '');
  const creatorName = get(message, 'metadata.creator.name', '');
  const ticketText = __t(`${MSG_KEY}.creator.ticket`, { ticket });
  const explanationText = isBrand
    ? __t(`${MSG_KEY}.brand.explanation`, { creatorName })
    : __t(`${MSG_KEY}.creator.explanation`, { campaignName });
  const reason = get(message, 'metadata.externalReasonDetail', '');
  const reasonText = __t(`${MSG_KEY}.creator.reason`, { reason });

  if (isBrand) {
    return (
      <React.Fragment>
        {renderAvatar('report-inside-circle-custom-fg')}
        <div className="payout-rescheduled-other">
          <div
            className="payout-rescheduled-other__explanation"
            dangerouslySetInnerHTML={{ __html: explanationText }}
          />
          <ContactUs />
        </div>
      </React.Fragment>
    );
  }

  return (
    <React.Fragment>
      {renderAvatar('report-inside-circle-custom-fg')}
      <div className="payout-rescheduled-other">
        {ticket ? (
          <div
            className="payout-rescheduled-other__ticket"
            dangerouslySetInnerHTML={{ __html: ticketText }}
          />
        ) : null}
        <div
          className="payout-rescheduled-other__explanation"
          dangerouslySetInnerHTML={{ __html: explanationText }}
        />
        <div
          className="payout-rescheduled-other__explanation"
          dangerouslySetInnerHTML={{ __html: reasonText }}
        />
        <div
          className="payout-rescheduled-other__advice"
          dangerouslySetInnerHTML={{ __html: __t(`${MSG_KEY}.creator.advice`) }}
        />
        <ContactUs />
      </div>
    </React.Fragment>
  );
};

export default PayoutRescheduledOther;
